<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2>Eventi di oggi e di domani</h2>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="6" style="margin-bottom: 0.5vh">
        <h3>
          Velocità scroller: {{ this.dayEventViewerSecondsSpeed }}s per pagina
        </h3>
        <v-slider
          v-model="settings.scrollerSpeed"
          step="1"
          min="1"
          max="8"
          thumb-label
          ticks
        ></v-slider>
      </v-col>
      <v-col cols="6" class="py-1" style="margin-bottom: 1vh"> </v-col>
      <v-col cols="6" style="margin-bottom: 0.5vh">
        <h3>Eventi per pagina: {{ settings.maxItemPerPage }}</h3>
        <v-slider
          v-model="settings.maxItemPerPage"
          step="1"
          min="1"
          max="8"
          thumb-label
          ticks
        ></v-slider> 
      </v-col>
      
    </v-row>
  </v-container>
</template>
<script> 
export default {
  props:{ 
    dayEventViewerSettings: { type: Object, default: null },
    
  },
  watch:{
    dayEventViewerSettings(old,newV){
      this.settings=newV;
    }
  },
  
  created() {
    this.settings=this.dayEventViewerSettings;
    // this.settings.planner.daysToShow = [0,1,2,3,4,5]; 
  },
  mounted() {
    //    this.loadSettings();
    //  this.$refs.frmEditPlanner.SetPlannerSettings(this.settings.planner);
  },
  computed: {
    dayEventViewerSecondsSpeed() {
      let num = 10 / this.settings.scrollerSpeed;
      return 10 - this.settings.scrollerSpeed + 1; // Math.round(num * 100) / 100
    },
  },
  methods: {
     SetSettings(cnfg){
      this.settings=cnfg;
    }, 
    GetSettings() {return this.settings},
   
  },
  data() {
    return {
      settings: {
         settings: {},
       
      },
    };
  },
  components: { 
  },
};
</script>
